module.exports = __webpack_public_path__ + "static/media/ca1.d574a807.jpg";